import { atom } from 'jotai';

/**
 * True while NavAccountLogin's form has focus. AppLayout reads this to keep the collapsed
 * sidebar rail expanded on mouse-leave — otherwise the rail snaps shut mid-typing and the
 * unmounted form loses whatever the patient had already entered.
 */
export const navAccountLoginActiveAtom = atom(false);
